import Tag from "components/BaseWidgets/tag";
import GoPremiumCard from "components/CustomWidgets/goPremiumCard";
import ProgressAvatar from "components/CustomWidgets/progressAvatar";
import React from "react";
import "./style.scss";
import { usePremium } from "context/PremiumContext";
import { profileVerification } from "utils/profileVerification";

function ProfileDetails({ profileData, isLoading }) {
  const { isPremium } = usePremium();

  return (
    <div className="profile-details">
      <div className="details-section">
        <ProgressAvatar profileData={profileData} isLoading={isLoading} />
        <div className="mt-3 flex flex-col gap-1-5 items-center">
          <div className="flex items-center gap-2">
            <span className="font-title-normal person-name">
              {profileData?.name}
            </span>
            <span className="verification-icons flex items-center gap-1">
              {profileVerification(profileData?.verification_type)}
            </span>
          </div>
          <p className="font-body-md2">{profileData?.aec_id}</p>
        </div>
        {!isPremium && (
          <Tag variant="selection" className="tag-comp" readOnly>
            Free member
          </Tag>
        )}
      </div>
      {!isPremium && (
        <GoPremiumCard
          title="Upgrade to premium & connect without limits!"
          buttonText="Upgrade plan"
          className="premium-card"
          plaNavigation={true}
          redirect
        />
      )}
    </div>
  );
}

export default ProfileDetails;
